import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-horses-race-badges',
    templateUrl: 'horses-race-badges.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HorsesRaceBadgesComponent {
    @Input() resulted = false;
    @Input() rule4Expected?: boolean;

    constructor(public sitecore: Sitecore) {}
}
